export default __webpack_public_path__ + "static/media/bosch.cc6855ae.png";